<template>
    <div class="page-not-found">
        <div class="wrapper">
            <h2>{{ $t('pageNotFound.pageNotFound')}}</h2>
            <v-btn class="back" @click="goBack">&#8592;{{ $t('pageNotFound.goBack')}}</v-btn>
        </div>
    </div>
</template>


<script>
    export default {
        methods:{
          goBack(){
            this.$router.go(-1);
          }
        }
    }
</script>

<style lang="less" scoped>

    .page-not-found{
        background: #cbf3f0;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

        .wrapper{
            position: relative;
            width: 100%;
            height: 100%;

            h2{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                text-align: center;
                color: #ff9f1c;
                font-size: 32px;
                text-transform: uppercase;
            }
            .back{
                position: absolute;
                top: 57%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }

</style>